/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { OptionComplexIcon } from '../models/option-complex-icon';
export interface FieldDefinitionOption {

  /**
   * Is the option selectable?
   */
  active?: boolean | null;

  /**
   * Icon Name
   */
  icon?: string | null;

  /**
   * For complex icons that stack and/or rotate/scale etc..
   */
  iconStack?: Array<OptionComplexIcon> | null;

  /**
   * Display Text
   */
  label?: string | null;

  /**
   * Sequence
   */
  order?: number | null;

  /**
   * Unique Identifier
   */
  value?: any | null;
}

export class FieldDefinitionOption {
  active?: boolean | null;
  icon?: string | null;
  iconStack?: OptionComplexIcon[] | null;
  label?: string | null;
  order?: number | null;
  value?: any | null;

  constructor(value: FieldDefinitionOption) {
    this.active = value?.active;
    this.icon = value?.icon;
    this.iconStack = value?.iconStack?.map((x) => new OptionComplexIcon(x));
    this.label = value?.label;
    this.order = value?.order;
    this.value = value?.value;
  }
}
